import UserCartLayout from '@/components/user/layouts/user-cart-layout';
import { useCsrfRefresh } from '@/hooks/use-csrf-refresh';
import { type BreadcrumbItem } from '@/types';
import { type PropsWithChildren } from 'react';
import { ScrollToTopButton } from '../scroll-to-top-button';
import { StickyVoucher } from '../sticky-voucher';
import { WebFooter } from './web-footer';
import { WebHeader } from './web-header';

interface WebLayoutTemplateProps {
  breadcrumbs?: BreadcrumbItem[];
}

export default function WebLayoutTemplate({ children }: PropsWithChildren<WebLayoutTemplateProps>) {
  // Ensure CSRF token is always up to date
  useCsrfRefresh();

  return (
    <UserCartLayout>
      <>
        <WebHeader />
        <main className="bg-[#F4F5F9]">{children}</main>
        <WebFooter />
        <ScrollToTopButton />
        <StickyVoucher />
      </>
    </UserCartLayout>
  );
}
